export default class BlockTestimony {
	static init() {

		let blocks = document.querySelectorAll('.block-testimony');

		blocks.forEach( (block) => {
			const swiper = block.querySelector(".swiper");
			const prev = block.querySelector(".swiper-custom-button-prev");
			const next = block.querySelector(".swiper-custom-button-next");
			const swiperElement = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				spaceBetween: 20,
				speed: 600,
				breakpoints: {
					768: {
						spaceBetween: 60
					}
				},
				navigation: {
					prevEl: prev,
					nextEl: next
				},
				on : {
					slideChangeTransitionStart : (s) => {
						swiperElement.slides.forEach( (slide) => {

							const card = slide.querySelector('.testimony-card');
							const styleActive = card.dataset.styleActive;

							if( slide.classList.contains('swiper-slide-active') ){
								// this.removeClassByPrefix( card, 'section-white' );
								// card.classList.add(styleActive);
							} else {
								// this.removeClassByPrefix( card, styleActive );
								// card.classList.add('section-white');
							}

						});
					}

				}
			});

		});
	}

	static removeClassByPrefix(node, prefix) {
		const regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
		node.className = node.className.replace(regx, '');
		return node;
	}

}
